<route>
{
    "name": "invoices-index",
    "meta": {
        "title": "Lista facturi emise",
        "requiresAuth": true,
        "permissions": ["manager", "sef_de_unitate", "secretar", "secretar_secundar"],
        "fail": "/403"
    }
}
</route>
<template>
  <company-layout>
      <v-container fluid grid-list-xl>
          <v-row>
              <v-col>
                  <index></index>
              </v-col>
          </v-row>
      </v-container>
  </company-layout>
</template>

<script>
import CompanyLayout from "Layouts/Company.vue";
import Index from 'Components/invoices/Index'

export default {
    components: {
        CompanyLayout,
        Index
    }
};
</script>
